import React, { useEffect } from "react";
import { actionCreators } from "./redux/lifetimeValueByMembershipsSagas";
import { useDispatch, useSelector } from "react-redux";

import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import MembershipTypeFilter from "./smartComponents/MembershipTypeFilter";
import PieChart from "../../../../components/pieChart/pieChart";
import { DataPoints } from "./smartComponents/DataPoints";
import DatePicker from "./smartComponents/DatePicker";
import "./LifetimeValueByMembership.scss";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import LifeTimeValueLearnText from "./smartComponents/LifeTimeValueLearnText";
import MembersViewFilter from "./smartComponents/MembersViewFilter";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import LifetimeTable from "./smartComponents/LifetimeTable";
import { UpdateBtns } from "./smartComponents/UpdateBtns";

const MembershipLengthModule = (props) => {
  const dispatch = useDispatch();
  const { currencySymbol, qa } = useSelector((state) => state.commonReducer.commonProps);
  const initialRequest = useSelector((state) => state.lifetimeValueByMembership.initialRequest);
  const updatesLoading = useSelector((state) => state.lifetimeValueByMembership.updatesLoading);
  const isLoading = useSelector((state) => state.lifetimeValueByMembership.isLoading);
  const {
    table_data = [],
    pie_chart = [],
    data_points
  } = useSelector((state) => state.lifetimeValueByMembership.table);
  const membership_types = useSelector(
    (state) => state.lifetimeValueByMembership.filters.membership_types
  );
  const members_view = useSelector(
    (state) => state.lifetimeValueByMembership.selectedFilters.members_view
  );

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const content = () => {
    return (
      <div>
        {membership_types.length ? (
          <div id="override-edit-selection-bar" className="edit-selections-bar">
            <div className="top-filters">
              <div className="left-side">
                <div className="select-box" style={{ width: "160px" }}>
                  <p className="offers-title">View</p>
                  <MembersViewFilter />
                </div>
                <div className="select-box" style={{ width: "160px" }}>
                  <p className="offers-title">Membership Types</p>
                  <MembershipTypeFilter />
                </div>
              </div>

              <div className="right-side">
                {members_view.id === "all_time_members" ? (
                  <>
                    <div className="select-box" style={{ width: "360px" }}>
                      <p className="offers-title">Date Range</p>
                      <CustomDateRanges />
                    </div>
                    <div className="select-box-no-width date-range-select-box">
                      <p className="offers-title">Date</p>
                      <DatePicker />
                    </div>
                  </>
                ) : null}
                {members_view.id !== "all_time_members" ? (
                  <ReactDatePicker
                    calendarEndDate={props.calendarEndDate}
                    disabled
                    startDate={props.calendarEndDate}
                  />
                ) : null}
              </div>
            </div>
            <UpdateBtns params={props} />
          </div>
        ) : null}

        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : pie_chart.length ? (
          <>
            <div style={{ display: "flex", alignItems: "center" }}>
              <DataPoints dataPoints={data_points} isUserQa={qa} />
              <div className="pie-chart">
                <PieChart
                  width={810}
                  height={300}
                  data={pie_chart}
                  addOtherLabel={false}
                  showLegend
                  legendPosition="right"
                  legendTooltipPosition="left"
                  currency={currencySymbol}
                />
              </div>
            </div>
            {table_data?.length > 0 ? <LifetimeTable /> : null}
          </>
        ) : (
          <p className="error">No data available</p>
        )}
      </div>
    );
  };

  return (
    <div id="lifetimeValueByMembership">
      <SectionToggle
        title="Lifetime Value by Membership Type"
        isLoading={isLoading}
        content={content()}
        autoHeight
        learnMore={<LifeTimeValueLearnText />}
      />
    </div>
  );
};

export default React.memo(MembershipLengthModule);
